import React, { Fragment } from "react";
import { useSelector } from "react-redux";

const Stepper = (props) => {
	const { activeStep, paymentMethod, t } = props;
	const isTourist = useSelector((state) =>
		Boolean(state?.BalanceReducer?.payloadAfterLogIn?.isTourist),
	);

	let temp = "";
	if (activeStep === 1) {
		temp = "stepCol firstStep active";
	} else if (activeStep === 0) {
		temp = "stepCol firstStep";
	}

	let forceLeft;
	if (paymentMethod === "voucher") {
		forceLeft = "stepText forceLeft";
	} else {
		forceLeft = "stepText";
	}

	return (
		<div className={`paymentSteps ${isTourist ? "tourist" : ""}`}>
			<div className="paymentStepsContainer">
				<ul className="paymentStepsBar">
					{paymentMethod === "voucher" ? (
						<Fragment>
							<li
								className={
									activeStep === 0
										? "stepCol firstStep active"
										: "stepCol middleStep active completed halfCompleted"
								}
							>
								<span className={forceLeft}>{t("wayOfPayment")}</span>
							</li>
							<li
								className={
									activeStep === 1
										? "stepCol lastStep active"
										: "stepCol lastStep"
								}
							>
								<span className="stepText">{t("completePayment")}</span>
							</li>
						</Fragment>
					) : (
						<Fragment>
							<li
								className={
									activeStep === 0
										? "stepCol firstStep active"
										: "stepCol firstStep active completed halfCompleted"
								}
							>
								<span className="stepText">{t("chooseMoney")}</span>
							</li>
							<li
								className={
									activeStep === 1 || activeStep === 0
										? temp
										: "stepCol middleStep active completed halfCompleted"
								}
							>
								<span className="stepText">{t("wayOfPayment")}</span>
							</li>
							<li
								className={
									activeStep === 2
										? "stepCol lastStep active"
										: "stepCol lastStep"
								}
							>
								<span className="stepText">{t("completePayment")}</span>
							</li>
						</Fragment>
					)}
				</ul>
			</div>
		</div>
	);
};

export default Stepper;
